
var getSearchButton = document.querySelector('.nav-search');

var searchHorizontalWrapper = document.querySelector('.search-horizontal-wrapper');

function showHideSearch() {
  var searchResults = document.querySelector('.search-results');

  if (searchResults.classList.contains('search-results-visible')) {
    document.querySelector('.search-results').classList.remove('search-results-visible');
    // document.querySelector('html').style.overflow = 'visible';
  } else {
    document.querySelector('.search-results').classList.add('search-results-visible');
    document.querySelector('#search-field').focus();
    // document.querySelector('html').style.overflow = 'hidden';
  }
}

if (searchHorizontalWrapper) {
  searchHorizontalWrapper.addEventListener('click', showHideSearch);
}

if (getSearchButton) {
  document.querySelector('.search-results-close').addEventListener('click', showHideSearch);
  getSearchButton.addEventListener('click', showHideSearch);
} else {
  getSearchButton.style.display = 'none';
}


var getNavContent = document.querySelector('.nav');
var getNavMobileButton = document.querySelector('.nav-mobile');

function showHideNav() {
  var searchResults = document.querySelector('.search-results');

  if (getNavContent.classList.contains('nav-visible')) {
    getNavContent.classList.remove('nav-visible');
  } else {
    getNavContent.classList.add('nav-visible');
  }
}


if (getNavMobileButton) {
  getNavMobileButton.addEventListener('click', showHideNav);
}




var getStripePriceButton = document.querySelectorAll('a[data-members-price]');

for (var i = 0; i < getStripePriceButton.length; i++) {
  getStripePriceButton[i].addEventListener('click', function(event) {



    var getStripePriceButtonDataPrice = event.target.getAttribute('data-members-price');
    var getStripePriceButtonDataPlan = event.target.getAttribute('data-members-plan');
    var stripeTransactionId = getStripePriceButtonDataPlan+new Date().getTime();

    gtag('event', 'purchase', {
      "transaction_id": stripeTransactionId,
      "value": getStripePriceButtonDataPrice,
      "currency": "USD",
      "items": [
        {
          "id": getStripePriceButtonDataPlan,
          "name": getStripePriceButtonDataPlan,
          "quantity": 1,
          "price": getStripePriceButtonDataPrice
        }
      ]
    });


  });
}
